export const setSessionByName = (key: string, value: any) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  
  export const getSessionByName = (key: string) => {
    const item: any = sessionStorage.getItem(key);
    try {
      return JSON.parse(item);
    } catch (e) {
      return item;
    }
  };
  
  export const removeSessionByName = (key: string) => {
    sessionStorage.removeItem(key);
  };